/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface Promo
 */
export interface Promo {
  /**
   * Уникальный идентификатор акции
   * @type {number}
   * @memberof Promo
   */
  id?: number
  /**
   * Статус активности акции
   * @type {boolean}
   * @memberof Promo
   */
  active?: boolean
  /**
   * Название акции
   * @type {string}
   * @memberof Promo
   */
  name?: string
  /**
   * Заголовок акции
   * @type {string}
   * @memberof Promo
   */
  title?: string
  /**
   * Описание акции
   * @type {string}
   * @memberof Promo
   */
  description?: string
}

/**
 * Check if a given object implements the Promo interface.
 */
export function instanceOfPromo(value: object): value is Promo {
  return true
}

export function PromoFromJSON(json: any): Promo {
  return PromoFromJSONTyped(json, false)
}

export function PromoFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): Promo {
  if (json == null) {
    return json
  }
  return {
    id: json['id'] == null ? undefined : json['id'],
    active: json['active'] == null ? undefined : json['active'],
    name: json['name'] == null ? undefined : json['name'],
    title: json['title'] == null ? undefined : json['title'],
    description: json['description'] == null ? undefined : json['description'],
  }
}

export function PromoToJSON(value?: Promo | null): any {
  if (value == null) {
    return value
  }
  return {
    id: value['id'],
    active: value['active'],
    name: value['name'],
    title: value['title'],
    description: value['description'],
  }
}
